function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M22.4,17.3c0.6,0.5,1.1,1.1,1.7,1.6c0.7,0.7,1.7,1.1,2.6,1.1c0.9,0,1.9-0.4,2.6-1.1c0.6-0.5,1.1-1.1,1.7-1.6 c3.8-3.7,7.6-7.3,11.4-11c1.5-1.4,1.3-3.8,0-5.2c-1.4-1.5-3.8-1.3-5.2,0c-0.6,0.5-1.1,1.1-1.7,1.6c-2.9,2.8-5.9,5.7-8.8,8.5 c-2.9-2.8-5.9-5.7-8.8-8.5c-0.6-0.5-1.1-1.1-1.7-1.6c-1.4-1.3-3.8-1.5-5.2,0c-1.3,1.4-1.5,3.8,0,5.2C14.7,9.9,18.6,13.6,22.4,17.3z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M22.4,39.4c0.6,0.5,1.1,1.1,1.7,1.6c0.7,0.7,1.7,1.1,2.6,1.1c0.9,0,1.9-0.4,2.6-1.1c0.6-0.5,1.1-1.1,1.7-1.6 c3.8-3.7,12.6-12.3,16.4-15.9c1.5-1.4,1.3-3.8,0-5.2c-1.4-1.5-3.8-1.3-5.2,0c-0.6,0.5-1.1,1.1-1.7,1.6 c-2.9,2.8-10.9,10.6-13.8,13.4c-2.9-2.8-10.9-10.6-13.8-13.4c-0.6-0.5-1.1-1.1-1.7-1.6c-1.4-1.3-3.8-1.5-5.2,0 c-1.3,1.4-1.5,3.8,0,5.2C9.8,27.2,18.6,35.8,22.4,39.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M52.2,36.1c-1.4-1.5-3.8-1.3-5.2,0c-0.6,0.5-1.1,1.1-1.7,1.6c-2.9,2.8-15.8,15-18.7,17.8 c-2.9-2.8-15.8-15-18.7-17.8c-0.6-0.5-1.1-1.1-1.7-1.6c-1.4-1.3-3.8-1.5-5.2,0c-1.3,1.4-1.5,3.8,0,5.2C4.9,45,18.6,58,22.4,61.6 c0.6,0.5,1.1,1.1,1.7,1.6c0.7,0.7,1.7,1.1,2.6,1.1c0.9,0,1.9-0.4,2.6-1.1c0.6-0.5,1.1-1.1,1.7-1.6C34.7,58,48.4,45,52.2,41.3 C53.7,39.9,53.6,37.5,52.2,36.1z"
}));

var SvgArrow = function SvgArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 53.3 64.3",
    style: {
      enableBackground: "new 0 0 53.3 64.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow.ff560d93.svg";
export { ForwardRef as ReactComponent };